var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen w-full bg-gradient overflow-hidden grid grid-rows-5 select-none"},[_c('div',{staticClass:"flex flex-col justify-center items-center row-span-1"}),_c('div',{staticClass:"row-span-3"},[_c('router-view',{staticClass:"flex justify-center items-center"})],1),_c('FooterInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }